export const formatExpirationDate = expirationDate => {
  let cardMonth = expirationDate.charAt(0) + expirationDate.charAt(1)
  let cardYear =
    "20" +
    expirationDate.charAt(expirationDate.length - 2) +
    expirationDate.charAt(expirationDate.length - 1)
  let todayMonth = new Date().getMonth() + 1
  let todayYear = new Date().getFullYear()
  if (todayMonth > cardMonth && todayYear >= cardYear) {
    return "expired"
  } else if (cardMonth === "01") {
    return "Jan " + cardYear
  } else if (cardMonth === "02") {
    return "Feb " + cardYear
  } else if (cardMonth === "03") {
    return "Mar " + cardYear
  } else if (cardMonth === "04") {
    return "Apr " + cardYear
  } else if (cardMonth === "05") {
    return "May " + cardYear
  } else if (cardMonth === "06") {
    return "Jun " + cardYear
  } else if (cardMonth === "07") {
    return "Jul " + cardYear
  } else if (cardMonth === "08") {
    return "Aug " + cardYear
  } else if (cardMonth === "09") {
    return "Sep " + cardYear
  } else if (cardMonth === "10") {
    return "Oct " + cardYear
  } else if (cardMonth === "11") {
    return "Nov " + cardYear
  } else if (cardMonth === "12") {
    return "Dec " + cardYear
  }
}

export const getCardIcon = cardMaker => {
  cardMaker = cardMaker.toLowerCase()
  if (cardMaker === "amex") {
    return "fab fa-cc-amex"
  } else if (cardMaker === "diners-club") {
    return "fab fa-cc-diners-club"
  } else if (cardMaker === "discover") {
    return "fab fa-cc-discover"
  } else if (cardMaker === "jcb") {
    return "fab fa-cc-jcb"
  } else if (cardMaker === "mc") {
    return "fab fa-cc-mastercard"
  } else if (cardMaker === "paypal") {
    return "fab fa-cc-paypal"
  } else if (cardMaker === "stripe") {
    return "fab fa-cc-stripe"
  } else if (cardMaker === "visa") {
    return "fab fa-cc-visa"
  } else if (cardMaker === "card") {
    return "fas fa-credit-card"
  } else if (cardMaker === "google-wallet") {
    return "fab fa-google-wallet"
  } else {
    return "fas fa-credit-card"
  }
}

export const convertAmountToTwoDecimalPlace = amount =>
  parseFloat(amount).toFixed(2)
export const convertUSDollarsCurrency3LettersToCurrencySymbol =
  currencyLetters => {
    if (currencyLetters === "USD") {
      return "$"
    } else {
      return currencyLetters
    }
  }

export const capitalizeFirstLetterOfCardName = cardMaker => {
  return cardMaker.charAt(0).toUpperCase() + cardMaker.slice(1)
}

export const maskString = inputStr => {
  if (!inputStr || typeof inputStr !== "string") {
    return ""
  }

  const length = inputStr.length
  const maskLength = length > 4 ? length - 4 : 0
  const mask = "x".repeat(maskLength)
  const revealed = inputStr.slice(-4)

  return mask + revealed
}

export const getUserOS = () => {
  const userAgent = window.navigator.userAgent
  const platform = window.navigator.platform
  const macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"]
  const windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"]
  const iosPlatforms = ["iPhone", "iPad", "iPod"]
  let os = null

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = "Mac OS"
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = "iOS"
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = "Windows"
  } else if (/Android/.test(userAgent)) {
    os = "Android"
  } else if (!os && /Linux/.test(platform)) {
    os = "Linux"
  }

  return os
}

export const getUserBrowserType = () => {
  const userAgent = navigator.userAgent
  let browserName

  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = "Chrome"
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = "Firefox"
  } else if (userAgent.match(/safari/i)) {
    browserName = "Safari"
  } else if (userAgent.match(/opr\//i)) {
    browserName = "Opera"
  } else if (userAgent.match(/edg/i)) {
    browserName = "Edge"
  } else {
    browserName = "Unknown"
  }

  return browserName
}

export const getUserIP = () => {
  return fetch("https://api.ipify.org?format=json")
    .then(response => response.json())
    .then(data => data.ip)
    .catch(error => {
      console.error("Error fetching IP:", error)
      return null
    })
}
